module.exports = __webpack_public_path__ + "img/MW_Telegram_Instruction_4.d72ac0b3.gif";